import { Form, Input, InputNumber, Select, Button, Row, Col, Card, Upload, message, UploadFile, UploadProps } from 'antd';
import React, { useContext, useState } from 'react'
import { UploadOutlined, DollarOutlined } from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
import { PromiseSesionContext } from '../../../machines/ErrorMachine';
import { createNewProduct } from '../../../api/Products';
import { GlobalContext } from '../../../context/GlobalContext';
import { Option } from 'antd/es/mentions';
import { Franchise } from '../../../models/Franchise';
import { Category } from '../../../models/Category';
import { FaBoxOpen, FaMoneyBillTrendUp, FaMotorcycle } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';

interface Props {
  setPreviewUrl?: React.Dispatch<React.SetStateAction<string | null>>
}
const CreateNewProduct = ({setPreviewUrl}:Props) => {
    const { categories, franchises } = useContext(GlobalContext);
    const navigate = useNavigate();
  
    const {sendError} = useContext(PromiseSesionContext);
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [loading, setLoading] = useState<boolean>(false);


const onFinish = async (values: any) => {
  try {
  setLoading(true)
  const formData = new FormData();

  // Los campos numéricos llegan como números desde AntD, 
  // pero FormData los convertirá a strings. NestJS se encargará de parsearlos.
  Object.keys(values).forEach((key) => {
    if (values[key] !== undefined && values[key] !== null) {
      formData.append(key, values[key].toString());
    }
  });

// 2. Extracción corregida según tu log de consola
  if (fileList.length > 0) {
    // Como vimos en tu captura, fileList[0] YA ES el archivo (objeto File)
    const fileToUpload = fileList[0]; 

    console.log("Archivo capturado directamente:", fileToUpload);

    // Verificamos si es un archivo válido antes de añadirlo
    if (fileToUpload instanceof File || fileToUpload instanceof Blob) {
      console.log("Entrando al segundo if: El archivo es válido.");
      formData.append('image', fileToUpload); 
    } else {
      // Por si acaso AntD lo devolviera envuelto en alguna otra circunstancia
      const fallbackFile = (fileToUpload as any).originFileObj;
      if (fallbackFile) {
        console.log("Cargando desde originFileObj (fallback)");
        formData.append('image', fallbackFile);
      }
    }
  }

    console.log("file list", formData.get('image'))
    console.log("formdata", formData)
    const producto = await createNewProduct(formData)
    sendError({ type: 'ERROR', data: { message: 'producto creado', type:"success" } });
    setLoading(false)

    window.location.reload();

  } catch (error) {
    setLoading(false)
    // Aquí puedes usar tu errorMachine para manejar el error
    sendError({ type: 'ERROR', data: { message: 'Error al guardar el producto' } });
  }
};

const uploadProps: UploadProps = {
  onRemove: () => {
    setFileList([]);
    if(setPreviewUrl){
      setPreviewUrl(null)
    }
  },
  beforeUpload: (file) => {
    // Aquí 'file' es el archivo binario real
    // Lo guardamos en el estado manualmente para asegurar que no se pierda
    setFileList([file as any]); 
    // Generamos la URL temporal
    if(setPreviewUrl){
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
    }
    return false; // Evita la subida automática
  },
  fileList,
};

  
  return (
<Card title="Crear Nuevo Producto" style={{ maxWidth: 800}}>
      <Form form={form} layout="vertical" onFinish={onFinish} disabled={loading}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="name" label="Nombre" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item name="status" label="Estatus" rules={[{ required: true }]} initialValue={"available"}>
              <Select placeholder="Selecciona">
                <Select.Option value={"available"}>Disponible</Select.Option>
                <Select.Option value={"soon"}>Proximamente</Select.Option>
                <Select.Option value={"sold out"}>Agotado</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item name="description" label="Descripción">
              <TextArea rows={3} />
            </Form.Item>
          </Col>

          {/* Sección de Carga de Imagen */}
          <Col span={8}>
            <Form.Item label="Imagen del Producto">
              <Upload {...uploadProps}>
                <Button icon={<UploadOutlined />}>Seleccionar Imagen</Button>
              </Upload>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="category_id" label="Categoría" rules={[{ required: true }]} initialValue={1}>
              <Select placeholder="Selecciona" options={categories.map((c:Category)=>{
                return {value: c.id, label:c.name}
              })}>
              </Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="franchise_id" label="Franquicia" rules={[{ required: true }]}>
              <Select placeholder="Selecciona" options={franchises.map((f:Franchise)=>{
                return {value:f.id, label:f.name}
              })}>
              </Select>
            </Form.Item>
          </Col>




            <Col span={8}>
            <Form.Item name="quantity" label="Cantidad" rules={[{ required: true }]} initialValue={1}>
              <InputNumber style={{ width: '100%' }} prefix={<FaBoxOpen />} precision={0} />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="cashPrice" label="Precio" rules={[{ required: true }]} initialValue={2.5}>
              <InputNumber style={{ width: '100%' }} prefix={<DollarOutlined />} precision={1} />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item name="discount" label="Descuento">
              <InputNumber style={{ width: '100%' }} prefix={<FaMoneyBillTrendUp />} precision={0} />
            </Form.Item>
          </Col>


          <Col span={12}>
            <Form.Item name="location" label="Ubicacion" rules={[{ required: true }]} initialValue={"B6"}>
              <Input />
            </Form.Item>
          </Col>


          <Col span={12}>
            <Form.Item name="priceDeliveryDiscount" label="Descuento para delivery" rules={[{ required: true }]} initialValue={0.5}>
              <InputNumber style={{ width: '100%' }} prefix={<FaMotorcycle />} precision={1} />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" htmlType="submit" block style={{ backgroundColor: '#EF366F', borderColor: '#EF366F' }}>
            Guardar Producto
          </Button>
        </Form.Item>
      </Form>
    </Card>
  )
}

export default CreateNewProduct